import { defineStore } from "pinia";
import EnergyCalculation from "./EnergyCalculation";

export const energyCalculationStore = defineStore('energyCalculation', {
    state: () => ({
            savedPower: 0,
            soldSensors: 0,
            savingPowerPerMinute:0,
            saveEnergyPerYearPerSensor: 0,
            totalInvest: 0,
            avgRoiInMonth: 0,
            startDate: "",
            energyPrice: 0,
            daysSinceStart: 0
        })
    ,
    actions: {
        calculateSavings() {
            this.energyPrice = EnergyCalculation.getEnergyPrice()
            this.daysSinceStart = EnergyCalculation.getDaysSinceStart()
        
            let save = EnergyCalculation.getSavingUnitsPerSecounds()
            this.soldSensors = EnergyCalculation.getSoldSensorsNowSecound()
            this.totalInvest = EnergyCalculation.getSoldSensorsNowSecound() * EnergyCalculation.pricePerSensor
            this.savingPowerPerMinute = EnergyCalculation.getSavingWattPerMinute() * EnergyCalculation.getSoldSensorsNowSecound()
            this.saveEnergyPerYearPerSensor = EnergyCalculation.getYearSavingPerSensor();
            this.savedPower = save
           
            this.startDate = EnergyCalculation.startDate.format("YYYY-MM-DD")
            this.avgRoiInMonth = EnergyCalculation.pricePerSensor / (EnergyCalculation.getYearSavingPerSensor() / 12 / 1000 * EnergyCalculation.energyPrice)
        },
        changeMonth(value) {
            EnergyCalculation.changeMonth(value)
        },
        changeDate(startDate) {
            EnergyCalculation.setStartDate(startDate)
        },
        setPrice(newPrice) {
            EnergyCalculation.setEnergyPrice(newPrice)
        },
        setSoldSensors(value) {
            EnergyCalculation.setSoldSensorsPerDay(value/365)
        },
        overwriteSensorSaving(value) {
            EnergyCalculation.overwriteSensorSaving(value)
        }
    }
})